import "../src/global/global-mobile"

import "@modules/vue-modals/ad-free"
import "@modules/vue-modals/age-verification"

import "@modules/location/LocationSelector"
import "@modules/solads/solads"

import "@modules/azm/filter-selection/show-results-button.ts"

import "@modules/stars/styles.css"
import "@modules/stars-profile/mobile.css"
import "@modules/stars/stars-post"
import "@modules/stars-profile/swiper-mobile.ts"
import "@modules/stars/royal-slider.ts"
import "@modules/tracking/previous-next-advert-cookie"
import "@modules/attribute-swiper/attribute-swiper.css"
import "@modules/single-page/gallery/gallery.css"
import "@modules/vue-modals/ad-free.js"
import "@modules/vue-modals/coins"
import "@modules/vue-modals/age-verification.js"

import { initGallery, initSharedGallery } from "@modules/single-page/gallery/gallery.ts"
import StarsPost from "@modules/stars/stars-post/StarsPost"
import "../src/stars/galerie.css"

const posts = new StarsPost(this)

posts.loadCurrentStarsPostsFilterForStarsProfile()
initGallery()
initSharedGallery()
